<div
  class="lic-popup-item theme-popup-licenseItem theme-popup-licenseItemActive theme-popup-licenseItem-hover"
  (click)="showFeatures($event, trackLicense.id)"
  [ngClass]="{ 'lic-popup-item--active  theme-popup-licenseItemActive': isLicenseActive }"
>
  <div class="lic-popup-item__content">
    <div
      class="lic-popup-item__checkbox theme-popup-licenseCheckColor theme-popup-licenseCheckColorActive"
      [ngClass]="{ 'lic-popup-item__checkbox--active  theme-popup-licenseCheckBorder': isLicenseActive }"
    >
      @if (isLicenseActive) {
        <span class="btv-icon-btn-check theme-popup-licenseCheckColorActive"></span>
      }
    </div>
    <div class="lic-popup-item__descr">
      <h3 class="lic-popup-item__title">{{ trackLicense.title }}</h3>
      <bmcore-license-bulk-discount [lg]="lg" [trackLicense]="trackLicense" [isPopup]="true">
      </bmcore-license-bulk-discount>
    </div>
    <p class="lic-popup-item__price theme-popup-licensePriceColor">{{ trackLicense.price }} {{ currencySign }}</p>
  </div>

  @if (isLicenseActive) {
    <ul class="lic-popup-item__features">
      @for (feature of trackLicense.features; track feature) {
        <li class="common-license-item">{{ feature.title }}</li>
      }
    </ul>
  }
</div>
